import Component from '../abstracts/Component';

export default class ShowFormComponent extends Component{

  get SELECTORS() {
    return {
      showFormBtn: '.show-form-button',
      formToShow: '.js-validate-form'
    };
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      event.preventDefault();
      console.log('triggered');
      if ($(this.SELECTORS.showFormBtn).length) {
        console.log('entered if');
        $(this.SELECTORS.formToShow).css('display', 'block');

        $(event.currentTarget).css('display', 'none');
      }
    }, 'body', this.SELECTORS.showFormBtn);
  }

  render() {
    this.log("Rendering...")
    this.bindEvents();
  }
}
